import { render, staticRenderFns } from "./ProcesoDetalle.vue?vue&type=template&id=44617dab&scoped=true"
import script from "./ProcesoDetalle.vue?vue&type=script&lang=js"
export * from "./ProcesoDetalle.vue?vue&type=script&lang=js"
import style0 from "./ProcesoDetalle.vue?vue&type=style&index=0&id=44617dab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44617dab",
  null
  
)

export default component.exports